import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import {
  displayMessageString
} from '#components/generics/js/control/message/display.js'
import { close } from '#utilities/js/lightboxes/menus/dropdown.js'
import { elements } from '../styles.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async (button) => {
    const { ownerDocument, value: buttonValue } = button
    const { clipboard } = ownerDocument.defaultView.navigator
    const { confirmation_text } = scope(button)
    const dropdown = one(`.${elements.dropdown}`, ownerDocument)

    if (dropdown) {
      close()
    }

    await clipboard.writeText(buttonValue)

    displayMessageString(confirmation_text)
  }
})

export default button => {
  onClick.listen(button)
}
